module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Light-Hestia.0734115.woff";